import moment from "moment-timezone";
import _ from "lodash";

import { TotalTimeSpentResult } from "src/core/dashboard/api/widget-data.api";

import {
  DisplayRangeType,
  groupByDisplayRange
} from "../../utils";
import { TotalTimeSpentValue } from "../TotalTimeSpentWidget";
import { GraphDataType } from "../../WidgetTotalValueSwitcher";

/**
 * Helper to group total tickets by date
 *
 * @param totalTimeSpent A list of flat totalTimeSpent data
 * @param displayRange DisplayRangeType
 * @returns
 *
 * ### Example.
 *
 * **In:**
 * ```
 * const totalTimeSpent = [
 *  {
      "date": "2022-01-31T00:00:00.000Z",
      "count": 1,
      "totalTime": "90"
    },
    {
      "date": "2022-01-31T00:00:00.000Z",
      "count": 1,
      "totalTime": "90"
    },
    {
      "date": "Thu Feb 03 2022 00:00:00",
      "count": 1,
      "totalTime": "90"
    }
 * ]
 * const displayRange = "month"
 * const graphDataType = "value"
 * ```
 * **Out:**
 * ```
 *[
    {
      "date": "2022-01-01T00:00:00.000Z",
      "value": 180
    },
    {
      "date": "2022-02-01T00:00:00.000Z",
      "value": 90
    }
  ]
 * ```
 */
export const groupTotalTimeSpent = (totalTimeSpent: TotalTimeSpentResult, displayRange: DisplayRangeType, graphDataType: GraphDataType): TotalTimeSpentValue[] => {
  const result: TotalTimeSpentValue[] = [];
  // Group the data based on displayRange
  const groupedTimeSpentData = groupByDisplayRange(totalTimeSpent, displayRange);

  // Loop grouped data to form the result, ensuring to include date and all relevant counts accumulated
  for (const groupDate in groupedTimeSpentData) {
    const accumulativeTotals = { value: 0 };

    groupedTimeSpentData[ groupDate ].forEach(row => {
      accumulativeTotals.value += graphDataType === "total" ? row.count : typeof row.totalTime === "string" ? parseInt(row.totalTime, 10) : row.totalTime;
    });

    const dataItem: TotalTimeSpentValue = {
      date: moment.utc(groupDate).toDate(),
      ...accumulativeTotals
    };

    // Force header to include date day if displayRange not by month
    if (displayRange !== "month") {
      dataItem.toolTipHeader = moment.utc(groupDate).format("Do MMMM YYYY");
    }

    result.push(dataItem);
  }

  return result;
};
